export default __webpack_public_path__ + "static/media/1.d9147a73.png";